'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    &:not(:last-child) {\n      &:after {\n        display: none;\n      }\n    }\n  '], ['\n    &:not(:last-child) {\n      &:after {\n        display: none;\n      }\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _ProductPageIcons = require('pricing-pages-unified-ui/constants/ProductPageIcons');

var _ProductPageIcons2 = _interopRequireDefault(_ProductPageIcons);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ProductContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ProductList__ProductContainer'
})(['display:flex;align-items:center;&:not(:last-child){margin-right:20px;&::after{margin-left:20px;font-weight:normal;color:', ';content:\'|\';}}', ';'], _colors.BATTLESHIP, _responsiveBreakpoints2.default.phone(_templateObject));

var Product = function Product(_ref) {
  var iconKey = _ref.iconKey,
      body = _ref.body;

  return _react2.default.createElement(
    ProductContainer,
    null,
    _react2.default.createElement(_UIImage2.default, {
      className: 'display-inline m-right-2',
      height: 13,
      width: 13,
      src: _ProductPageIcons2.default[iconKey],
      responsive: false
    }),
    _react2.default.createElement(
      'span',
      null,
      body
    )
  );
};

var ProductList = function ProductList(_ref2) {
  var edition = _ref2.edition;

  var langBase = 'pricingPage.pages.growthSuite';
  return _react2.default.createElement(
    _UIFlex2.default,
    { wrap: 'wrap' },
    _react2.default.createElement(Product, {
      iconKey: 'crm',
      body: _react2.default.createElement(_FormattedMessage2.default, { message: langBase + '.crm' })
    }),
    _react2.default.createElement(Product, {
      iconKey: 'marketing',
      body: _react2.default.createElement(_FormattedMessage2.default, { message: langBase + '.marketing.' + edition })
    }),
    _react2.default.createElement(Product, {
      iconKey: 'sales',
      body: _react2.default.createElement(_FormattedMessage2.default, { message: langBase + '.sales.' + edition })
    }),
    _react2.default.createElement(Product, {
      iconKey: 'service',
      body: _react2.default.createElement(_FormattedMessage2.default, { message: langBase + '.service.' + edition })
    })
  );
};

exports.default = ProductList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/ProductList.js
// module id = 773
// module chunks = 3 4